// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.layout_global_aside__Iv4P2 {
    overflow: auto;
    height: 100vh;
    left: 0;
    top: 0;
    bottom: 0;
    background-color: #040724 !important;
    transition: all 0.3s ease;
    display: block;
 
  }
  
 

  .layout_ant-menu__AHIW9 {
    background-color: #040724 !important;
  }
  
  .layout_logo_case__qFAK\\+ {
    height: 64px;
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: #e4e6fe !important;
  }
  
  .layout_ant-drawer-content__XHyp- {
    background-color: #040724 !important;
  }
  
  .layout_content__-05v8 {
    margin: 2px;
    overflow: initial;
    background-color: #f2f6f9 !important;
  }
  
  .layout_content__-05v8 .layout_inner__hCLHP {
    background-color: #f2f6f9 !important;
    text-align: center;
    height: 100%;
    overflow: hidden auto;
  }
  
  .layout_global_header__uxAz- {
    display: flex;
    position: relative;
    justify-content: space-between;
    padding: 0;
    background-color: white;
    position: sticky;
    top: 0;
    z-index: 1;
    box-shadow: rgba(0, 0, 0, 0.08) 0 0 0 1px;
  }
  
  .layout_global_header__uxAz- .layout_header_btn__z5Cep,
  .layout_global_header__uxAz- .layout_mobile_toggle__3KWhu {
    font-size: 16px;
    width: 64px;
    height: 64px;
  }

  .layout_global_header__uxAz- .layout_mobile_toggle__3KWhu {
    display: none;
  }
  
  .layout_ant-drawer-body__LCq5e {
    background-color: #040724 !important;
  }
  
  .layout_logoutButton__PQOES {
    background-color: red;
    width: 90%;
    margin: 10px auto;
    font-weight: 600;
    font-size: 16px;
  }
  @media (max-width: 700px) {
    .layout_ant-layout-sider__HY\\+rK {
      display: none!important; /* Make sure it's hidden */
    }
    .layout_header_btn__z5Cep {
      display: none !important;
    }
    .layout_mobile_toggle__3KWhu {
      display: block !important; /* Show mobile toggle icon */
    }
  }
  `, "",{"version":3,"sources":["webpack://./src/components/Layout/layout.module.css"],"names":[],"mappings":"AAAA;IACI,cAAc;IACd,aAAa;IACb,OAAO;IACP,MAAM;IACN,SAAS;IACT,oCAAoC;IACpC,yBAAyB;IACzB,cAAc;;EAEhB;;;;EAIA;IACE,oCAAoC;EACtC;;EAEA;IACE,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,oCAAoC;EACtC;;EAEA;IACE,oCAAoC;EACtC;;EAEA;IACE,WAAW;IACX,iBAAiB;IACjB,oCAAoC;EACtC;;EAEA;IACE,oCAAoC;IACpC,kBAAkB;IAClB,YAAY;IACZ,qBAAqB;EACvB;;EAEA;IACE,aAAa;IACb,kBAAkB;IAClB,8BAA8B;IAC9B,UAAU;IACV,uBAAuB;IACvB,gBAAgB;IAChB,MAAM;IACN,UAAU;IACV,yCAAyC;EAC3C;;EAEA;;IAEE,eAAe;IACf,WAAW;IACX,YAAY;EACd;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,oCAAoC;EACtC;;EAEA;IACE,qBAAqB;IACrB,UAAU;IACV,iBAAiB;IACjB,gBAAgB;IAChB,eAAe;EACjB;EACA;IACE;MACE,uBAAuB,EAAE,0BAA0B;IACrD;IACA;MACE,wBAAwB;IAC1B;IACA;MACE,yBAAyB,EAAE,4BAA4B;IACzD;EACF","sourcesContent":[".global_aside {\n    overflow: auto;\n    height: 100vh;\n    left: 0;\n    top: 0;\n    bottom: 0;\n    background-color: #040724 !important;\n    transition: all 0.3s ease;\n    display: block;\n \n  }\n  \n \n\n  .ant-menu {\n    background-color: #040724 !important;\n  }\n  \n  .logo_case {\n    height: 64px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    background-color: #e4e6fe !important;\n  }\n  \n  .ant-drawer-content {\n    background-color: #040724 !important;\n  }\n  \n  .content {\n    margin: 2px;\n    overflow: initial;\n    background-color: #f2f6f9 !important;\n  }\n  \n  .content .inner {\n    background-color: #f2f6f9 !important;\n    text-align: center;\n    height: 100%;\n    overflow: hidden auto;\n  }\n  \n  .global_header {\n    display: flex;\n    position: relative;\n    justify-content: space-between;\n    padding: 0;\n    background-color: white;\n    position: sticky;\n    top: 0;\n    z-index: 1;\n    box-shadow: rgba(0, 0, 0, 0.08) 0 0 0 1px;\n  }\n  \n  .global_header .header_btn,\n  .global_header .mobile_toggle {\n    font-size: 16px;\n    width: 64px;\n    height: 64px;\n  }\n\n  .global_header .mobile_toggle {\n    display: none;\n  }\n  \n  .ant-drawer-body {\n    background-color: #040724 !important;\n  }\n  \n  .logoutButton {\n    background-color: red;\n    width: 90%;\n    margin: 10px auto;\n    font-weight: 600;\n    font-size: 16px;\n  }\n  @media (max-width: 700px) {\n    .ant-layout-sider {\n      display: none!important; /* Make sure it's hidden */\n    }\n    .header_btn {\n      display: none !important;\n    }\n    .mobile_toggle {\n      display: block !important; /* Show mobile toggle icon */\n    }\n  }\n  "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"global_aside": `layout_global_aside__Iv4P2`,
	"ant-menu": `layout_ant-menu__AHIW9`,
	"logo_case": `layout_logo_case__qFAK+`,
	"ant-drawer-content": `layout_ant-drawer-content__XHyp-`,
	"content": `layout_content__-05v8`,
	"inner": `layout_inner__hCLHP`,
	"global_header": `layout_global_header__uxAz-`,
	"header_btn": `layout_header_btn__z5Cep`,
	"mobile_toggle": `layout_mobile_toggle__3KWhu`,
	"ant-drawer-body": `layout_ant-drawer-body__LCq5e`,
	"logoutButton": `layout_logoutButton__PQOES`,
	"ant-layout-sider": `layout_ant-layout-sider__HY+rK`
};
export default ___CSS_LOADER_EXPORT___;
